import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { refundRequest, refundRequestTest } from "../../services/transaction";
import toast from "react-hot-toast";
import { useAuth } from "../../context/AuthContextProvider";

function TransactionModal({ setIsModalOpen, transactData }) {
  const { globalProfile } = useAuth();

  const [refund, setRefund] = useState(false);
  const [refundType, setRefundType] = useState("Full");
  const [refundAmount, setRefundAmount] = useState();
  const [refundReason, setRefundReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [reasonTouched, setReasonTouched] = useState(false);

  const isReasonValid = refundReason && refundReason.length >= 10;

  const payload = {
    transactionId: transactData?.id,
    refundType: refundType,
    refundAmount: refundAmount,
    reason: refundReason,
  };

  const refundReqFunc =
    globalProfile === "TEST" ? refundRequestTest : refundRequest;

  const handleRefundRequest = () => {
    setLoading(true);
    refundReqFunc(payload)
      .then(() => {
        toast.success("Refund request sent successfully");
        setLoading(false);
        setIsModalOpen(false);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Refund request failed");
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Dialog
      visible={true}
      onHide={() => setIsModalOpen(false)}
      header="Transaction Details"
      style={{ width: "450px", maxWidth: "95vw" }}
      dismissableMask
      draggable={false}
      resizable={false}
    >
      <div className="text-sm">
        <p className="py-2.5 flex justify-between border-b">
          <span className="font-semibold text-gray-700">Transaction ID:</span>
          <span>{transactData?.id}</span>
        </p>
        <p className="py-2.5 flex justify-between border-b">
          <span className="font-semibold text-gray-700">Customer Name:</span>
          <span>{transactData?.customerName || "N/A"}</span>
        </p>

        <p className="py-2.5 flex justify-between border-b">
          <span className="font-semibold text-gray-700">Customer Email:</span>
          <span className="truncate max-w-[220px]" title={transactData?.customerEmail}>
            {transactData?.customerEmail || "N/A"}
          </span>
        </p>

        <p className="py-2.5 flex justify-between border-b">
          <span className="font-semibold text-gray-700">Reference ID:</span>
          <span className="truncate max-w-[220px]" title={transactData?.referenceId}>
            {transactData?.referenceId}
          </span>
        </p>

        <p className="py-2.5 flex justify-between border-b">
          <span className="font-semibold text-gray-700">Transaction Date:</span>
          <span>
            {transactData?.initiated
              ? new Date(transactData.initiated).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })
              : "N/A"}
          </span>
        </p>
        <p className="py-2.5 flex justify-between border-b font-semibold">
          <span className="font-semibold text-gray-700">Transaction Amount:</span>
          <span>
            {transactData?.amount != null
              ? Number(transactData.amount).toFixed(2)
              : "0.00"}
          </span>
        </p>
        <p className="py-2.5 flex justify-between border-b">
          <span className="font-semibold text-gray-700">Scheme:</span>
          <span>{transactData?.scheme || "N/A"}</span>
        </p>
        <p className="py-2.5 flex justify-between border-b break-words">
          <span className="font-semibold text-gray-700">Description:</span>
          <span>{transactData?.description || "N/A"}</span>
        </p>
        <p className="py-2.5 flex justify-between border-b">
          <span className="font-semibold text-gray-700">Masked PAN:</span>
          <span>{transactData?.pan || "N/A"}</span>
        </p>
        <p className="py-2.5 flex justify-between border-b">
          <span className="font-semibold text-gray-700">Status:</span>
          <span className="font-semibold capitalize text-primary">
            {transactData?.status}
          </span>
        </p>
        <p className="py-2.5 flex justify-between border-b">
          <span className="font-semibold text-gray-700">Approval Code:</span>
          <span>{transactData?.approvalCode || "N/A"}</span>
        </p>

        <div className="mt-5">
          {!refund ? (
            <button
              onClick={() => setRefund(true)}
              className="text-white bg-primary hover:opacity-90 transition-opacity w-full h-[42px] rounded-[10px] font-medium"
            >
              Initiate Refund
            </button>
          ) : (
            <div className="pt-2">
              <h3 className="text-lg text-black-shade text-center font-bold pb-3 border-b mb-3">
                Refund Details
              </h3>
              <div className="flex flex-col gap-3">
                <div>
                  <label className="block text-xs font-semibold mb-1">
                    Refund Type
                  </label>
                  <select
                    className="border border-gray-300 outline-none rounded-lg p-2 w-full text-sm"
                    value={refundType}
                    onChange={(e) => setRefundType(e.target.value)}
                  >
                    <option value="Full">Full Refund</option>
                    <option value="Partial">Partial Refund</option>
                  </select>
                </div>
                {refundType === "Partial" && (
                  <div>
                    <label className="block text-xs font-semibold mb-1">
                      Refund Amount*
                    </label>
                    <input
                      onChange={(e) => setRefundAmount(e.target.value)}
                      className="border border-gray-300 rounded-lg outline-none p-2 w-full text-sm"
                      type="number"
                      placeholder="Enter amount"
                    />
                  </div>
                )}
                <div>
                  <label className="block text-xs font-semibold mb-1">
                    Refund Reason*
                  </label>
                  <input
                    onChange={(e) => setRefundReason(e.target.value)}
                    onBlur={() => setReasonTouched(true)}
                    className={`border rounded-lg outline-none p-2 w-full text-sm ${
                      reasonTouched && !isReasonValid
                        ? "border-red-500"
                        : "border-gray-300"
                    }`}
                    type="text"
                    placeholder="Enter reason (at least 10 chars)"
                  />
                  {reasonTouched && !isReasonValid && (
                    <p className="text-red-500 text-xs mt-1">
                      Reason must be at least 10 characters (
                      {refundReason?.length || 0}/10)
                    </p>
                  )}
                </div>
              </div>

              <div className="flex gap-2 mt-4">
                <button
                  type="button"
                  onClick={() => setRefund(false)}
                  className="flex-1 h-[42px] rounded-[10px] border border-gray-300 text-gray-700 hover:bg-gray-50 text-sm font-medium"
                >
                  Cancel
                </button>
                <button
                  onClick={handleRefundRequest}
                  disabled={
                    loading ||
                    !isReasonValid ||
                    (refundType === "Partial" && !refundAmount)
                  }
                  className="flex-1 text-white bg-primary disabled:opacity-50 hover:opacity-90 transition-opacity h-[42px] rounded-[10px] text-sm font-medium"
                >
                  {loading ? "Submitting..." : "Submit Refund"}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </Dialog>
  );
}

export default TransactionModal;
